import { OktaAuth } from "@okta/okta-auth-js";
import { getOktaConfigForEnvironment } from "./oktaEnvironments";

// Using memory storage for WebView2 compatibility in Excel
// This singleton uses staging as the default config, but tokens from any environment
// can be stored here since the tokenManager works regardless of the initial issuer
const defaultConfig = getOktaConfigForEnvironment("staging");

const oktaAuth = new OktaAuth({
  issuer: defaultConfig.issuer,
  clientId: defaultConfig.clientId,
  redirectUri: defaultConfig.redirectUri,
  scopes: defaultConfig.scopes,
  pkce: true,
  responseType: ["code"],
  tokenManager: {
    storage: "memory",
    autoRenew: true,
    expireEarlySeconds: 30,
  },
});

export default oktaAuth;
